var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error"},[_c(_setup.HelperViewStatus,{attrs:{"generic-error":"","button-label":"Tentar novamente","button-secondary":""},on:{"click":function($event){return _setup.emits('on-retry')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }